<template>
    <b-container fluid="true" class="py-3">
        <b-row no-gutters>
            <b-col order="2" order-sm="1" cols="12">
                <b-row no-gutters>
                        <ChartColumnWrapper
                            v-for="(activeItem, index) in availableLevelmeters"
                            :active-item="activeItem"
                            :key="`aig-${index}`"
                        ></ChartColumnWrapper>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    // utils
    import {mapGetters} from "vuex";
    import {sensorsGraphics, iconsUnits, showPlotLineFor} from "../../constants/sensors-constants";
    // mixins
    import chartContainerMixinOnly from "../../mixins/chartContainerMixinOnly";
    import chartSafeTooltipMixin from "@/mixins/chartSafeTooltipMixin";
    // constants
    import {autoStartSensors, autoStartTimeFrame} from "../../constants/sensors-constants";
    import {doNotShowTripleData, defaultMeasuringProfile} from "../../constants/chart-constants";
    // components
    import ChartColumnWrapper from "./ChartColumnWrapper";


    /**
     * Container for all levelmeter graphics. This is one tab's content.
     * There are 4 in total.
     * Also contains switcher buttons to the right.
     */

    export default {
        name: "ChartLevelmetersContainer",
        mixins: [chartSafeTooltipMixin, chartContainerMixinOnly],
        components: {
            ChartColumnWrapper
        },
        data() {
            return {
                sensorsGraphics,
                iconsUnits,
                containsMultiChartItem: false,
                tabTitle: "sensors-page.tab-title-generic"
            }
        },
        computed: {
            // getDamLevelmeters returns dict original data and array with sorted keys
            ...mapGetters(['getDamLevelmeters']),
            /**
             *
             * @returns {[]} Piezometers info with refined structure
             */
            availableLevelmeters() {
                const availableLevelmeters = [];

                for (let levelmeterName of this.getDamLevelmeters[1]) {
                    // this list contains the same data, but with more usable structure
                    availableLevelmeters.push({
                        name: levelmeterName,
                        title: this.safeGetTooltip(levelmeterName),
                        value: this.getDamLevelmeters[0][levelmeterName],
                        metric: this.iconsUnits[levelmeterName].unit || '',
                        icon: this.iconsUnits[levelmeterName].icon || '',
                        alternative: false,
                        autoStart: autoStartSensors.includes(levelmeterName),
                        autoStartTimeFrame: autoStartTimeFrame,
                        showTripleData: doNotShowTripleData,
                        showPlotLine: showPlotLineFor.includes(levelmeterName),
                        measuringProfile: defaultMeasuringProfile,
                        containsMultiChartItem: this.containsMultiChartItem
                    });
                }
                return availableLevelmeters;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";
    @import "../../assets/scss/mixins";
</style>